import { connect } from 'react-redux';
import InvoiceLinesSlidingPanel from './InvoiceLinesSlidingPanel';
import {bindActionCreators} from "redux";
import {
  clearAllInvoiceLineFilters
} from 'redux/invoiceLinesFilters/InvoiceLinesFiltersActions';

const mapStateToProps = ({ manageUser, invoices }) => ({
  userPermissions: manageUser.userPermissions,
  selectedInvoice: invoices.invoice,
  fetchingInvoice: invoices.fetchingInvoice
});

const mapDispatchToProps = dispatch => ({
  invoiceLinesFiltersActions: bindActionCreators({ clearAllInvoiceLineFilters },dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceLinesSlidingPanel);



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/InvoiceLinesSlidingPanelConnector.js